export default __webpack_public_path__ + "static/media/Globe.83b97581.svg";